import { array } from 'fp-ts';
import { useMemo } from 'react';
import { getCurrentEnterpriseTaxEnvironmentCode } from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import { useCommanderSelector } from '@mews-commander/utils';
import { useGlobalizationResultQuery } from './useGlobalizationResultQuery';

export const useCurrentEnterpriseTaxCodes = () => {
    const { data } = useGlobalizationResultQuery();
    const currentEnterpriseLegalEnvironmentCode = useCommanderSelector((state) =>
        getCurrentEnterpriseTaxEnvironmentCode(state)
    );

    const taxEnvironments = data?.taxEnvironments;

    return useMemo(() => {
        if (!currentEnterpriseLegalEnvironmentCode || !taxEnvironments || array.isEmpty(taxEnvironments)) {
            return [];
        }

        const legalTaxEnvironments = taxEnvironments.find(
            (taxEnvironment) => taxEnvironment.code === currentEnterpriseLegalEnvironmentCode
        );

        return legalTaxEnvironments?.taxationCodes ?? [];
    }, [currentEnterpriseLegalEnvironmentCode, taxEnvironments]);
};
